<div class="molv-select-wrapper">
    <select class="molv-select" [(ngModel)]="value" (ngModelChange)="valueChange.emit($event)">

        @if (placeholder) {
        <option [ngValue]="null">
            {{ placeholder }}
        </option>
        }

        @for (o of options; track $index) {
        <option [ngValue]="o.value">
            {{ o.label }}
        </option>
        }

    </select>
</div>